import * as React from 'react';
import { DefaultLayout } from '../layout/DefaultLayout.js';

export default function PageNotFound() {
  return (
    <DefaultLayout>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
          padding: '5rem 0',
        }}
      >
        <h2
          style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center' }}
        >
          Page not found
        </h2>
      </div>
    </DefaultLayout>
  );
}
